module.exports = __webpack_public_path__ + "public/images/employee-eye.5334113c9f763a64cd3fa075d8f16a8e.svg";